import {businessCategories as mcc} from 'lib/businessCategories';
import {useMemo} from 'react';

interface Option {
  label: string;
  value: string;
}

export const useBusinessCategories = () => {
  return useMemo(() => {
    const categories: {label: string; range: [number, number]}[] = [
      {label: 'Retail Outlet Services', range: [5000, 5599]},
      {label: 'Clothing Stores', range: [5600, 5699]},
      {label: 'Miscellaneous Stores', range: [5700, 7299]},
      {label: 'Business Services', range: [7300, 7999]},
      {label: 'Professional Services', range: [8000, 8999]},
      {label: 'Contracted Services', range: [1500, 2999]},
      {label: 'Agricultural Services', range: [1, 1499]},
      {label: 'Car Rental', range: [3300, 3499]},
      {label: 'Transportation Services', range: [4000, 4799]},
      {label: 'Utility Services', range: [4800, 4999]},
      {label: 'Lodging', range: [3500, 3999]},
      {label: 'Airlines', range: [3000, 3299]},
      {label: 'Government Services', range: [9000, 9999]},
      {label: 'Other', range: [0, 0]}
    ];

    const result = [];
    for (const category of categories) {
      const options: Option[] = [];

      for (const mccCode in mcc) {
        const code = Number(mccCode);
        if (code >= category.range[0] && code <= category.range[1]) {
          const {description, moneiXFMid} = mcc[mccCode];
          const label = options.push({
            label: `${description}${moneiXFMid ? ' (F)' : ''}`,
            value: mccCode
          });
        }
      }

      options.sort((a, b) => a.label.localeCompare(b.label));

      if (options.length > 0) {
        result.push({label: category.label, options});
      }
    }
    return result;
  }, []);
};
